import DataTable, { Order } from 'datatables.net-dt';
import '../../../node_modules/datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt';
import '../../../node_modules/datatables.net-buttons/js/buttons.html5.js';
import '../../../node_modules/datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-buttons-dt';
import '../../../node_modules/datatables.net-buttons-dt/js/buttons.dataTables.js';
import '../../../node_modules/datatables.net-responsive-dt/js/responsive.dataTables.js';

import Papa from 'papaparse';

import jQuery from 'jquery';
import Drupal from 'drupal';
import once from 'once';


// Import the type definitions for DataTables Buttons
import 'datatables.net-buttons/js/dataTables.buttons';
import moment from "moment";

(function initCsvToDatatable($) {

    class CsvToDatatable {
        private readonly $: JQueryStatic;

        $dataTableContainer: JQuery<HTMLElement>;

        // Define columns to be filtered
        private readonly filterableColumns: string[] = ['type', 'action', 'state', 'locations', 'status', 'phenotypes'];

        private readonly presetPhenotypes: string[] = ['AP-Agronomic Properties', 'BR-Bacterial Resistance', 'FR-Fungal Resistant', 'HR-Herbicide Resistance', 'IR-Insect Resistant', 'MG-Marker Gene', 'NR-Nematode Resistant', 'OO-Other', 'PQ-Product Quality', 'VR-Virus Resistance'];

        private readonly presetStatuses: string[] = ['Acknowledged', 'Denied', 'Incomplete', 'Issued', 'Pending', 'Withdrawn'];

        private readonly presetStates: string[] = [
            'AL-Alabama',
            'AK-Alaska',
            'AZ-Arizona',
            'AR-Arkansas',
            'CA-California',
            'CO-Colorado',
            'CT-Connecticut',
            'DE-Delaware',
            'DC-District of Columbia',
            'FL-Florida',
            'GA-Georgia',
            'GU-Guam',
            'HI-Hawaii',
            'ID-Idaho',
            'IL-Illinois',
            'IN-Indiana',
            'IA-Iowa',
            'KS-Kansas',
            'KY-Kentucky',
            'LA-Louisiana',
            'ME-Maine',
            'MD-Maryland',
            'MA-Massachusetts',
            'MI-Michigan',
            'MN-Minnesota',
            'MS-Mississippi',
            'MO-Missouri',
            'MT-Montana',
            'NE-Nebraska',
            'NV-Nevada',
            'NH-New Hampshire',
            'NJ-New Jersey',
            'NM-New Mexico',
            'NY-New York',
            'NC-North Carolina',
            'ND-North Dakota',
            'MP-Northern Mariana Islands',
            'OH-Ohio',
            'OK-Oklahoma',
            'OR-Oregon',
            'PA-Pennsylvania',
            'PR-Puerto Rico',
            'RI-Rhode Island',
            'SC-South Carolina',
            'SD-South Dakota',
            'TN-Tennessee',
            'TX-Texas',
            'VI-US Virgin Islands',
            'UT-Utah',
            'VT-Vermont',
            'VA-Virginia',
            'WA-Washington',
            'WV-West Virginia',
            'WI-Wisconsin',
            'WY-Wyoming',
        ];

        private filterOptions: string[][] = [];

        private dataTableInstance: any;

        /**
         * Store all processed datatables.
         */
        static csvToDatatables = [] as CsvToDatatable[];

        /**
         * @param $
         * @param {HTMLElement} csvToDatatable
         *  A DOM element.
         */
        constructor($: JQueryStatic, csvToDatatable: HTMLElement) {
            this.$ = $;

            /**
             * @type {JQuery}
             */
            this.$dataTableContainer = $(csvToDatatable);


            $.fn.dataTable.ext.errMode = 'none';

            this.init();

        }

        init() {
            this.$dataTableContainer.each((index, container) => {
                const $container = $(container);
                const csvUrl = $container.data('csv-url');



                if (csvUrl && container instanceof HTMLElement) {
                    this.populateDataTable(csvUrl, container);
                }
            });
        }

        private getSearchQueryParams(): { [key: string]: string } {
            const urlParams = new URLSearchParams(window.location.search);
            const searchFilters: { [key: string]: string } = {};

            // Iterate through query params that are used for searching.
            for (const [key, value] of urlParams) {
                // Check if the key corresponds to a search filter.
                if (this.isSearchFilter(key)) {
                    searchFilters[key] = value;
                }
            }

            return searchFilters;
        }

        private getDropdownQueryParams(): { column: string; filter: string; search: string } {
            const urlParams = new URLSearchParams(window.location.search);
            const column = urlParams.get('column') || '';
            const filter = urlParams.get('filter') || '';
            const search = urlParams.get('s') || '';

            return { column, filter, search };
        }


        private applySearchFilters(dataTableInstance, filters): boolean {
            let filtersChanged = false;
            let combinedSearch = '';

            for (const value of Object.values(filters)) {
                if (value) {
                    combinedSearch += value + ' ';
                }
            }

            combinedSearch = combinedSearch.trim();

            const currentSearch = dataTableInstance.search();

            // If there's a change with the search, clear the existing search filters.
            if (currentSearch !== combinedSearch) {
                dataTableInstance.search(combinedSearch).draw();
                filtersChanged = true;
            }

            return filtersChanged;
        }

        private applyDropdownFilters(dataTableInstance, queryParam): boolean {
            const { column, filter, search, fixed } = queryParam;
            let filtersChanged = false;

            const columnIndex = this.getColumnIndexByName(column, dataTableInstance);

            if (columnIndex !== null) {
                const currentFilter = dataTableInstance.column(columnIndex).search();
                if (currentFilter !== filter) {
                    if (fixed) {
                        dataTableInstance.column(columnIndex).search.fixed(column, filter);  // Apply the new column filter
                    }
                    else {
                        dataTableInstance.column(columnIndex).search(filter);  // Apply the new column filter
                    }
                    filtersChanged = true;
                }
            }

            const currentSearch = dataTableInstance.search();

            if (search && currentSearch !== search) {
                if (fixed) {
                    dataTableInstance.column(columnIndex).search.fixed(column, search);  // Apply the new search filter as a fixed filter
                }
                else {
                    dataTableInstance.search(search);  // Apply the new search filter
                }
                filtersChanged = true;
            }

            return filtersChanged;
        }

        private applyFilters(dataTableInstance, filters, dropdownFilters, filteredColumn, filteredValue) {
            let filtersChanged = false;

            if (Object.keys(filters).length || Object.keys(dropdownFilters).length || filteredValue) {
                filtersChanged = this.applySearchAndDropdownFilters(dataTableInstance, filters, dropdownFilters, filteredColumn, filteredValue);
            }

            return filtersChanged;
        }

        private applySearchAndDropdownFilters(dataTableInstance, filters, dropdownFilters, filteredColumn, filteredValue) {
            let filtersChanged = false;

            // Apply search filters
            if (Object.keys(filters).length) {
                filtersChanged = this.applySearchFilters(dataTableInstance, filters);
            }

            // Apply dropdown filters
            if (Object.keys(dropdownFilters).length) {
                filtersChanged = this.applyDropdownFilters(dataTableInstance, dropdownFilters) || filtersChanged;
            }

            // Apply filtered value
            if (filteredValue) {
                filtersChanged = this.applyDropdownFilters(dataTableInstance, { column: filteredColumn, filter: '', search: filteredValue, fixed: true }) || filtersChanged;
            }

            return filtersChanged;
        }



        // Find the index of a column in the DataTable by name
        private getColumnIndexByName(columnName: string, dataTableInstance: any) : number | null {
            columnName = columnName.trim().toLowerCase();

            let columnIndex: number | null = null;

            // Get and iterate over all columns
            dataTableInstance.columns().every( function ( index: number ) {
                const col = dataTableInstance.column(index);
                if (col.header().textContent.trim().toLowerCase() === columnName) {
                    columnIndex = index;
                    return false;   // stops iteration over columns
                }
                return true; // returns to next iteration (over columns)
            });

            return columnIndex;
        }

        private isSearchFilter(key: string): boolean {
            return key.startsWith('s');
        }

        /**
         * Normalize header string: replace <br> with newline so it's never put in the DOM as HTML.
         * (Raw <br> in header text causes jQuery selector errors in third-party scripts e.g. SiteImprove.)
         */
        private normalizeHeader(header: string): string {
            return header.replace(/<br\s*\/?>/gi, '\n').trim();
        }

        /**
         * Fix UTF-8 degree sign (bytes C2 B0) misinterpreted as Latin-1 and saved as two chars (U+00C2 + U+00B0 = "Â°").
         * Those characters are literally present in some uploaded CSVs; this collapses them to a single degree sign.
         */
        private normalizeCsvCellEncoding(value: unknown): unknown {
            if (typeof value !== 'string') {
                return value;
            }
            return value.replace(/\u00C2\u00B0/g, '\u00B0');
        }

        /**
         * True when a parsed CSV cell should be treated as empty (trailing Excel columns, null from dynamicTyping, etc.).
         */
        private isEmptyCsvValue(value: unknown): boolean {
            if (value === null || value === undefined) {
                return true;
            }
            if (typeof value === 'string') {
                const t = value.trim();
                return t === '' || t.toLowerCase() === 'null';
            }
            return false;
        }

        /**
         * Remove Papa Parse internal keys so they never become table columns.
         */
        private stripPapaRowArtifacts(row: Record<string, unknown>): Record<string, unknown> {
            const copy = { ...row };
            delete copy.__parsed_extra;
            return copy;
        }

        /**
         * Drop columns that are empty for every row, working from the last column backward
         * (fixes Excel-used-range trailing commas and blank header cells).
         */
        private stripTrailingEmptyCsvColumns(
            rows: Record<string, unknown>[],
            fieldOrder: string[],
        ): { rows: Record<string, unknown>[]; fields: string[] } {
            const cleanedRows = rows.map((r) => this.stripPapaRowArtifacts(r));
            let fields = fieldOrder.filter((name) => name !== '__parsed_extra');
            if (!fields.length || !cleanedRows.length) {
                return { rows: cleanedRows, fields };
            }
            while (fields.length > 0) {
                const key = fields[fields.length - 1];
                const allEmpty = cleanedRows.every((r) => this.isEmptyCsvValue(r[key]));
                if (!allEmpty) {
                    break;
                }
                fields = fields.slice(0, -1);
            }
            const trimmedRows = cleanedRows.map((r) => {
                const out: Record<string, unknown> = {};
                fields.forEach((f) => {
                    out[f] = r[f];
                });
                return out;
            });
            return { rows: trimmedRows, fields };
        }

        private async fetchCSVData(url: string): Promise<{ data: Record<string, unknown>[]; fields: string[] }> {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            // Decode as UTF-8 regardless of Content-Type charset (avoids Â° mojibake when
            // the server omits charset or declares a legacy encoding for UTF-8 bytes).
            const buffer = await response.arrayBuffer();
            const csvData = new TextDecoder('utf-8', { ignoreBOM: true }).decode(buffer);

            return new Promise((resolve, reject) => {
                Papa.parse(csvData, {
                    complete: (results) => {
                        const rows = (results.data || []) as Record<string, unknown>[];
                        const fieldOrder =
                            results.meta?.fields?.length
                                ? results.meta.fields
                                : rows[0]
                                  ? Object.keys(this.stripPapaRowArtifacts(rows[0]))
                                  : [];
                        const { rows: trimmedRows, fields } = this.stripTrailingEmptyCsvColumns(rows, fieldOrder);
                        resolve({ data: trimmedRows, fields });
                    },
                    error: (error) => {
                        reject(error);
                    },
                    skipEmptyLines: true,
                    header: true,
                    dynamicTyping: true, // Automatically converts strings to numbers or booleans if appropriate
                });
            });
        }


        private populateDataTable(url: string, tableContainer: HTMLElement) {
            // Show the loading element
            this.toggleLoadingElement(true);

            this.fetchCSVData(url)
                .then(({ data, fields }) => {
                    const that = this;
                    const dataTableElement = this.createDataTableElement(tableContainer);
                    this.destroyDataTableIfExists(dataTableElement);

                    if (!data.length) {
                        this.toggleLoadingElement(false);
                        return;
                    }

                    const rawHeaders = fields.length ? fields : Object.keys(data[0]);
                    const allNumericHeaders = rawHeaders.every((h) => /^\d+$/.test(String(h).trim()));
                    const headers = allNumericHeaders
                        ? rawHeaders.map((_, i) => `Column ${i}`)
                        : rawHeaders.map((h) => this.normalizeHeader(h));
                    const normalizedData = data.map((row) => {
                        const newRow: Record<string, unknown> = {};
                        rawHeaders.forEach((raw, i) => {
                            newRow[headers[i]] = this.normalizeCsvCellEncoding(row[raw]);
                        });
                        return newRow;
                    });
                    const selectedValue = this.$dataTableContainer.data('selected-column');
                    const secondSelectedValue = this.$dataTableContainer.data('second-selected-column');
                    const sortBy = this.$dataTableContainer.data('sort-order');
                    const selectedColumnIndex = headers.findIndex(header => header === this.normalizeHeader(selectedValue ?? ''));
                    const secondSelectedColumnIndex = headers.findIndex(header => header === this.normalizeHeader(secondSelectedValue ?? ''));

                    // Initialize DataTable
                    this.initializeDataTable(
                        normalizedData,
                        headers,
                        dataTableElement,
                        selectedColumnIndex,
                        secondSelectedColumnIndex,
                        sortBy,
                        url,
                    );

                    // Initialize filterOptions array
                    this.filterOptions = Array.from({length: headers.length}, () => []);

                    this.createFilters(headers);

                    this.addSearchInputs(headers);

                    const csvDownloadFiltered = $('.csv-download-filtered').detach();
                    const csvDownloadAll = $('.csv-download-all').detach();
                    const csvDownloadJson = $('.csv-download-json').detach();

                    $('#datatable-download')
                        .append(csvDownloadFiltered)
                        .append(csvDownloadAll)
                        .append(csvDownloadJson);

                    $(dataTableElement).find('thead').off('click.DT');

                    $(dataTableElement).find('thead').on('click', 'th', function (this: HTMLElement, e: any) {
                        e.preventDefault();

                        const dt_idx = $(this).data('dt-column');
                        const cols = that.dataTableInstance.columns()[0];
                        let order_array = new Array();
                        let new_order = new Array();

                        cols.forEach(function (col) {
                            const col_order = that.dataTableInstance.column(col).order()[0];
                            if (col == dt_idx) {
                                if (col_order == 'asc') {
                                    new_order = [col, 'desc'];
                                }
                                else if (col_order == 'desc') {
                                    new_order = [col, null];
                                }
                                else {
                                    new_order = [col, 'asc'];
                                }
                            }
                            else {
                                order_array.push([col, col_order]);
                            } 
                        });

                        order_array.push(new_order);

                        that.dataTableInstance.order(order_array);
                        that.dataTableInstance.draw();

                        if (new_order[1] == null) {
                            $(this).removeAttr("aria-sort");
                        }
                        else if (new_order[1] == 'asc') {
                            $(this).attr('aria-sort', 'ascending');
                        }
                        else if (new_order[1] == 'desc') {
                            $(this).attr('aria-sort', 'descending');
                        }
                    });

                    // Hide the loading element
                    this.toggleLoadingElement(false);
                })
                .catch((error) => {
                    // Handle error
                    console.error(error);
                });
        }

        private toggleLoadingElement(show: boolean) {
            const loadingElement = document.getElementById('loading');
            if (loadingElement) {
                loadingElement.classList.toggle('hidden', !show);
            }
        }

        private createDataTableElement(container: HTMLElement) {
            const table = document.createElement('table');
            table.classList.add('usa-table');
            container.appendChild(table);
            return table;
        }

        private destroyDataTableIfExists(tableElement: HTMLElement) {
            if ($.fn.DataTable.isDataTable(tableElement)) {
                $(tableElement).DataTable().destroy();
            }
        }

        /**
         * Base name for Buttons csvHtml5 export (extension .csv is appended by the button).
         * Derived from the source CSV URL path when possible.
         */
        private exportBasenameFromCsvUrl(csvUrl: string): string {
            let base = 'export';
            try {
                const pathname = new URL(csvUrl, typeof window !== 'undefined' ? window.location.href : undefined).pathname;
                const segment = pathname.split('/').pop();
                if (segment) {
                    base = segment.replace(/\.csv$/i, '');
                }
            } catch {
                // Invalid URL — keep default
            }
            base = base.trim() || 'export';
            base = base.replace(/[<>:"/\\|?*]+/g, '-').replace(/\s+/g, ' ').trim();
            return base || 'export';
        }

        private initializeDataTable(
            data: any[],
            headers: string[],
            dataTableElement: HTMLElement,
            selectedColumnIndex: number,
            secondSelectedColumnindex: number,
            sortBy: 'asc' | 'desc',
            sourceCsvUrl: string,
        ) {
            const columns = this.createColumns(headers, data);
            // const that = this; // reference to "this" for use within drawCallback
            const order: Order[] = [];
            if (selectedColumnIndex !== -1) {
                order.push({ idx: selectedColumnIndex, dir: sortBy });
            }
            if (secondSelectedColumnindex !== -1) {
                order.push({ idx: secondSelectedColumnindex, dir: sortBy });
            }
            
            // Get page length from data attribute, default to 10 if not specified
            const pageLength = parseInt(this.$dataTableContainer.data('page-length')) || 10;
            const csvExportBasename = this.exportBasenameFromCsvUrl(sourceCsvUrl);

            // Shared CSV export format: preserve header line breaks (\n), fix link URLs, leave blank cells empty
            // DataTables Buttons calls format.header(title, columnIndex, headerNode) - parameter order matters
            const columnTitles = columns.map((col) => String(col.title ?? ''));
            const csvExportFormat = {
                header: function (title: string, columnIndex: number, _headerNode?: unknown) {
                    const t = columnTitles[columnIndex];
                    if (t !== undefined && t !== '') return t;
                    if (title !== undefined && title !== null && String(title).trim() !== '' && !/^\d+$/.test(String(title).trim())) return String(title);
                    return `Column ${columnIndex}`;
                },
                body: function (data: any) {
                    // Leave blank cells empty instead of exporting "Null"
                    if (data === null || data === undefined || (typeof data === 'string' && data.trim().toLowerCase() === 'null')) {
                        return '';
                    }
                    if (typeof data === 'string' && data.startsWith('<a')) {
                        const parser = new DOMParser();
                        const htmlDoc = parser.parseFromString(data, 'text/html');
                        const link = htmlDoc.body.getElementsByTagName('a')[0];
                        if (!link) return data;
                        let href = link.getAttribute('href');
                        if (href !== null) {
                            // Only prepend base URL when href is relative (avoid duplicating full APHIS URL)
                            const isAbsolute = /^https?:\/\//i.test(href);
                            if (!isAbsolute) {
                                const baseUrl = window.location.protocol + '//' + window.location.host;
                                href = baseUrl + (href.startsWith('/') ? href : '/' + href);
                                link.setAttribute('href', href);
                            }
                            return link.outerHTML;
                        }
                    }
                    return data;
                },
            };

            const csvHtml5Button = {
                extend: 'csvHtml5',
                className: 'c-button',
                text: 'CSV',
                filename: csvExportBasename,
                charset: 'utf-8',
                bom: true,
                exportOptions: {
                    orthogonal: 'csv',
                    format: csvExportFormat,
                },
            };
            const csvHtml5Filtered = {
                extend: 'csvHtml5',
                className: 'csv-download-filtered c-button',
                text: 'Download Filtered Data',
                filename: csvExportBasename,
                charset: 'utf-8',
                bom: true,
                exportOptions: {
                    orthogonal: 'csv',
                    format: csvExportFormat,
                    modifier: {
                        search: 'applied',
                        order: 'applied',
                    },
                },
            };
            const csvHtml5All = {
                extend: 'csvHtml5',
                className: 'csv-download-all c-button',
                text: 'Download All Data',
                filename: csvExportBasename,
                charset: 'utf-8',
                bom: true,
                exportOptions: {
                    orthogonal: 'export',
                    format: csvExportFormat,
                },
            };
            
            this.dataTableInstance = $(dataTableElement).DataTable({
                data: data,
                columns: columns,
                order: order,
                ordering: true,
                orderClasses: true,
                orderMulti: true,
                autoWidth: false,
                responsive: true,
                pageLength: pageLength,
                lengthMenu: [[10, 20, 50, 100, -1], [10, 20, 50, 100, 'All']],
                columnDefs: [{
                    targets: '_all',
                    searchable: true,
                    orderable: true,
                }],
                language: {
                    paginate: {
                        previous: 'Previous',
                        next: 'Next'
                    }
                },
                layout: {
                    topStart: {
                        buttons: [
                            csvHtml5Button,
                            {
                                extend: 'print',
                                className: 'c-button',
                                text: 'Print',
                            },
                            csvHtml5Filtered,
                            csvHtml5All,
                            {
                                text: 'Download JSON',
                                className: 'csv-download-json c-button',
                                action: () => {
                                    const data = this.getDataArrayFromTable(dataTableElement);
                                    const json = JSON.stringify(data);
                                    const blob = new Blob([json], {type: 'application/json'});
                                    const url = URL.createObjectURL(blob);
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.download = 'data.json';
                                    link.click();
                                    URL.revokeObjectURL(url);
                                },
                            }
                        ]
                    },
                    bottomEnd: {
                        paging: {
                            firstLast: false
                        }
                    }
                }
            });

            // Ensure highlighting and aria-sort on initialization (first draw)
            this.updateAriaSortAttributes(dataTableElement);

            // Ensure rel=prev/next and crawlable links for pagination (Screaming Frog, etc.)
            this.updatePaginationRelAttributes(dataTableElement);

            // Ensure highlighting, aria-sort, and URL sync on every table draw
            this.dataTableInstance.on('draw.dt', () => {
                this.updateAriaSortAttributes(dataTableElement);
                this.updatePaginationRelAttributes(dataTableElement);
                this.syncUrlToTablePage();
            });

            this.applyFilters(this.dataTableInstance, this.getSearchQueryParams(), this.getDropdownQueryParams(), this.$dataTableContainer.data('filtered-column'), this.$dataTableContainer.data('filtered-value'));

            // Restore page from URL after filters (e.g. ?page=2) so link navigation shows the correct page
            const info = this.dataTableInstance.page.info();
            const urlPage = this.getPageFromUrl();
            let pageToShow = info.page;
            if (urlPage !== null && urlPage > 0) {
                const pageIndex = Math.min(urlPage - 1, info.pages - 1);
                pageToShow = Math.max(0, pageIndex);
            }
            this.dataTableInstance.page(pageToShow).draw(false);
        }

        /**
         * Reads page number from URL query (e.g. ?page=2). Returns 1-based page or null if missing/invalid.
         */
        private getPageFromUrl(): number | null {
            const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
            const p = params.get('page');
            if (p === null) return null;
            const n = parseInt(p, 10);
            return Number.isFinite(n) && n >= 1 ? n : null;
        }

        /**
         * Builds the current URL with a given page number (1-based) for crawlable pagination links.
         */
        private getPaginationUrl(pageNum: number): string {
            if (typeof window === 'undefined') return '#';
            const params = new URLSearchParams(window.location.search);
            params.set('page', String(pageNum));
            const q = params.toString();
            return window.location.pathname + (q ? '?' + q : '');
        }

        /**
         * Updates the browser URL to include ?page=N for the current table page,
         * so back/forward and shared links return to the correct page.
         */
        private syncUrlToTablePage(): void {
            if (typeof window === 'undefined' || typeof window.history === 'undefined') return;
            const info = this.dataTableInstance.page.info();
            const pageNum = info.page + 1;
            const url = this.getPaginationUrl(pageNum);
            if (url !== window.location.pathname + window.location.search) {
                window.history.replaceState(null, '', url);
            }
        }

        /**
         * Adds rel="prev" / rel="next" to pagination buttons and injects crawlable <a> links
         * so crawlers (e.g. Screaming Frog) can discover and follow paginated results.
         */
        private updatePaginationRelAttributes(dataTableElement: HTMLElement) {
            const info = this.dataTableInstance.page.info();
            const currentPage = info.page;
            const pages = info.pages;
            const $paging = this.$dataTableContainer.find('.dt-paging');
            if (!$paging.length) return;

            const pageNum = currentPage + 1;
            const prevPage = pageNum - 1;
            const nextPage = pageNum + 1;
            const prevUrl = this.getPaginationUrl(prevPage);
            const nextUrl = this.getPaginationUrl(nextPage);

            $paging.find('.dt-paging-button').each(function (this: HTMLElement) {
                const $btn = $(this);
                const text = $btn.text().trim().toLowerCase();
                if (text === 'previous') {
                    $btn.attr('rel', 'prev');
                } else if (text === 'next') {
                    $btn.attr('rel', 'next');
                }
            });

            $paging.find('.dt-paging-crawl-link').remove();
            const visuallyHidden = { position: 'absolute' as const, width: '1px', height: '1px', overflow: 'hidden', clip: 'rect(0,0,0,0)' };
            if (prevPage >= 1) {
                $('<a class="dt-paging-crawl-link">Previous</a>')
                    .attr({ rel: 'prev', href: prevUrl })
                    .css(visuallyHidden)
                    .prependTo($paging);
            }
            if (nextPage <= pages) {
                $('<a class="dt-paging-crawl-link">Next</a>')
                    .attr({ rel: 'next', href: nextUrl })
                    .css(visuallyHidden)
                    .appendTo($paging);
            }
        }

        /**
         * Updates aria-sort attributes and highlights all sorted columns.
         */
        private updateAriaSortAttributes(dataTableElement: HTMLElement) {
            // Get the current order from DataTables
            const order = this.dataTableInstance.order();
            const tableHeaders = $(dataTableElement).find('thead > tr >  th');

            // Clear all aria-sort attributes
            tableHeaders
                .removeAttr('aria-sort') // Remove stale aria-sort
                .removeClass('dt-ordering-asc dt-ordering-desc');

            // Apply new aria-sort attributes and classes
            order.forEach(([columnIndex, sortDirection]: [number, string]) => {
                const header = tableHeaders.eq(columnIndex);
                if (sortDirection === 'asc') {
                    header.attr('aria-sort', 'ascending').addClass('dt-ordering-asc');
                } else if (sortDirection === 'desc') {
                    header.attr('aria-sort', 'descending').addClass('dt-ordering-desc');
                }
            });
        }
        private getDataArrayFromTable(dataTableElement: HTMLElement): string[][] {
            const data: string[][] = [];
            jQuery(dataTableElement)
                .find('tbody tr')
                .each(function () {
                    const row: string[] = [];
                    jQuery(this)
                        .find('td')
                        .each(function () {
                            row.push(jQuery(this).text().trim());
                        });
                    data.push(row);
                });
            return data;
        }

        private createColumns(headers: string[], data: any[]) {
            // Check each column for empty data.
            const nonEmptyColumns = headers.filter((header) =>
                data.some((row) => !this.isEmptyCsvValue(row[header])),
            );
            return nonEmptyColumns.map((header) => this.createColumn(header));
        }

        private createColumn(header: string) {
            // If the header includes 'date', render it differently
            if (header.toLowerCase().includes('date')) {
                return {
                    title: header,
                    data: header,
                    render: (data, type) => this.dateRenderer(data, type)
                };
            }

            // else just return title and data
            return {
                title: header,
                data: header
            };
        }

        private dateRenderer(data: any, type: string) {
            if (type === 'sort' || type === 'type') {
                let transformedData: string;

                // Regular expression to check if data is in the date range format
                let isRangeFormat = /\d{2}\/\d{2}-\d{2}\/\d{2}\/\d{4}/.test(data);

                if (data === null) {
                    transformedData = '';
                }
                // Include any strings that are not dates.
                else if (data instanceof String  && data.includes("TBA")) {
                    // Return a far future date so this value is sorted at the end
                    transformedData = '9999/12/31';
                }
                else if (isRangeFormat) {
                    const [startDate] = data.split("-");

                    const formattedStartDate = moment(startDate, 'MM/DD/YYYY').format('YYYY/MM/DD');

                    transformedData = formattedStartDate;
                }
                else {
                    transformedData = moment(data, ['YYYY', 'MM/YYYY', 'MM/DD/YY', 'M/DD/YY', 'M/D/YY', 'MM/DD/YYYY', 'YYYY/MM']).format('YYYY/MM/DD');
                }
                return transformedData;
            } else {
                return data;
            }
        }

        private createFilters(headers: string[]) {
            const filterContainer = document.getElementById('datatable-filters');
            headers.forEach((header, index) => {
                if (this.filterableColumns.includes(header.trim().toLowerCase())) {
                    const filterLabel = document.createElement('label');
                    filterLabel.htmlFor = `filter-col${index}`;
                    filterLabel.innerText = `By ${header.trim()}`;

                    const filterSelect = document.createElement('select');
                    filterSelect.id = `filter-col${index}`;
                    filterSelect.addEventListener('change', this.handleFilterChange);
                    filterSelect.setAttribute('data-column-index', index.toString());

                    const filterOptionAll = document.createElement('option');
                    filterOptionAll.value = '';
                    filterOptionAll.text = 'All';
                    filterSelect.appendChild(filterOptionAll);

                    // Add specific options based on the header
                    if (header.trim().toLowerCase() === 'type' || header.trim().toLowerCase() === 'action') {
                        // Get unique values from the DataTable instance
                        const uniqueValues = new Set(this.dataTableInstance.column(index).data().toArray());

                        uniqueValues.forEach((val) => {
                            const value = String(val);
                            const filterOption = document.createElement('option');
                            filterOption.value = value;
                            filterOption.text = value;
                            filterSelect.appendChild(filterOption);
                        });
                    } else if (header.trim().toLowerCase() === 'phenotypes') {
                        this.presetPhenotypes.forEach((optionValue: string) => {
                            const filterOption = document.createElement('option');
                            filterOption.value = optionValue.substring(0, 3);
                            filterOption.text = optionValue;
                            filterSelect.appendChild(filterOption);
                        });
                    } else if (header.trim().toLowerCase() === 'status') {
                        this.presetStatuses.forEach((optionValue: string) => {
                            const filterOption = document.createElement('option');
                            filterOption.value = optionValue;
                            filterOption.text = optionValue;
                            filterSelect.appendChild(filterOption);
                        });
                    } else if (
                        header.trim().toLowerCase() === 'state' ||
                        header.trim().toLowerCase() === 'locations'
                    ) {
                        this.presetStates.forEach((optionValue: string) => {
                            const filterOption = document.createElement('option');
                            filterOption.value = optionValue.substring(0, 2);
                            filterOption.text = optionValue;
                            filterSelect.appendChild(filterOption);
                        });
                    } else {
                        const uniqueValues: string[] = Array.from<string>(
                            new Set(
                                this.dataTableInstance.rows().data().toArray().map((row) => row[index])
                            )
                        ).sort();
                        uniqueValues.forEach((optionValue: string) => {
                            const filterOption = document.createElement('option');
                            filterOption.value = optionValue;
                            filterOption.text = optionValue;
                            filterSelect.appendChild(filterOption);
                        });
                    }

                    filterContainer?.appendChild(filterLabel);
                    filterContainer?.appendChild(filterSelect);
                }
            });
        }

        private handleFilterChange = () => {
            const filterSelects = Array.from(
                document.getElementById('datatable-filters')?.getElementsByTagName(
                    'select'
                ) as HTMLCollectionOf<HTMLSelectElement>
            );

            this.dataTableInstance.search('').columns().search('').draw();

            filterSelects.forEach((select) => {
                const filterValue = select.value.trim();
                const columnIndex = parseInt(select.getAttribute('data-column-index') || '0', 10);

                if (filterValue) {
                    this.dataTableInstance.columns(columnIndex).search(filterValue);
                }
            });

            this.dataTableInstance.draw();
        };

        private addSearchInputs(headers: string[]) {
            const searchContainer = document.getElementById('datatable-search');

            const searchableColumns = [
                { label: 'Article', dataColumn: 'article' },
                { label: 'Institution', dataColumn: 'institution' },
                { label: 'Phenotype', dataColumn: 'phenotypes' },
                { label: 'Genotype', dataColumn: 'genotypes' },
                { label: 'All Fields', dataColumn: 'all-fields' }
            ];

            searchableColumns.forEach((column) => {
                const columnData = column.dataColumn;
                const columnIndex = headers.findIndex(
                    (header) => header.trim().toLowerCase() === columnData.toLowerCase()
                );

                if (columnIndex !== -1 && this.dataTableInstance.column(columnIndex).visible()) {
                    const searchInput = this.createSearchInput(column.label, columnData);
                    searchContainer?.appendChild(searchInput);

                    searchInput.addEventListener('input', this.handleSearchInput);
                }
            });

            // Add the "All Fields" search input
            const allFieldsInput = this.createSearchInput('All Fields', 'all-fields');
            searchContainer?.appendChild(allFieldsInput);

            allFieldsInput.addEventListener('input', this.handleSearchInput);
        }

        private createSearchInput(labelText: string, dataColumn: string): HTMLDivElement {
            const label = document.createElement('label');
            label.innerText = `Search ${labelText}`;

            const input = document.createElement('input');
            input.type = 'text';
            input.setAttribute('data-column', dataColumn);

            const container = document.createElement('div');
            container.appendChild(label);
            container.appendChild(input);

            return container;
        }

        private handleSearchInput = (event: Event) => {
            const searchTerm = (event.target as HTMLInputElement).value.trim().toLowerCase();
            const dataColumn = (event.target as HTMLInputElement).getAttribute('data-column');

            const searchValue = searchTerm.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'); // Escape special characters in the search term

            // Define columns to be searched
            const searchableColumns = [
                {label: 'Article', dataColumn: 'article'},
                {label: 'Institution', dataColumn: 'institution'},
                {label: 'Phenotype', dataColumn: 'phenotypes'},
                {label: 'Genotype', dataColumn: 'genotypes'},
                {label: 'All Fields', dataColumn: 'all-fields'},
            ];

            if (dataColumn === 'all-fields') {
                this.dataTableInstance.search(searchValue, true, false).draw();
            } else {
                const columnIndex = searchableColumns.findIndex(
                    (column) => column.dataColumn === dataColumn
                );
                const targetColumn = this.dataTableInstance
                    .columns()
                    .header()
                    .toArray()
                    .find((header) => this.$(header).text().trim() === searchableColumns[columnIndex].label);
                const targetIndex = this.dataTableInstance.column(targetColumn).index();
                this.dataTableInstance.column(targetIndex).search(searchValue, true, false).draw();
            }
        };
    }


    // Expose constructor in the public space.
    Drupal.CsvToDatatable = CsvToDatatable;

    /**
     * Process elements with the data-csv-url attribute.
     *
     * @type {Drupal~behavior}
     *
     * @prop {Drupal~behaviorAttach} attach
     *  Attaches csv-to-datatable behavior to elements with the data-csv-url attribute.
     */
    Drupal.behaviors.csvToDatatable = {
        attach(context) {
            const csvToDatatables = once('csvToDatatable', '.csv-to-datatable-container', context);
            if (csvToDatatables.length) {
                // initialize all sections.
                const il = csvToDatatables.length;
                for (let i = 0; i < il; i+=1) {
                    CsvToDatatable.csvToDatatables.push(
                        new CsvToDatatable(jQuery, csvToDatatables[i])
                    );
                }
            }
        },
    };

})(jQuery);

